import { makeStyles } from '@material-ui/core/styles'

// eslint-disable-next-line import/prefer-default-export
export const useStyles = makeStyles((theme) => ({
  button: {
    marginLeft: 15,
    marginRight: 15,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}))
